var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2230_42440)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2230_42440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 0H4C1.79086 0 0 1.49238 0 3.33333V16.6667C0 18.5076 1.79086 20 4 20H26C28.2091 20 30 18.5076 30 16.6667V3.33333C30 1.49238 28.2091 0 26 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 8.33333H17V0H13V8.33333H0V11.6667H13V20H17V11.6667H30V8.33333Z",
    fill: "#EA3323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.45087C8.381 3.55421 7.754 3.61921 7.126 3.64504C7.157 3.12171 7.235 2.60004 7.359 2.08337C6.789 2.14587 6.211 2.14587 5.641 2.08337C5.765 2.59921 5.843 3.12171 5.874 3.64504C5.246 3.61921 4.62 3.55421 4 3.45087C4.075 3.92587 4.075 4.40754 4 4.88254C4.619 4.77921 5.246 4.71421 5.874 4.68837C5.843 5.21171 5.765 5.73337 5.641 6.25004C6.211 6.18754 6.789 6.18754 7.359 6.25004C7.235 5.73421 7.157 5.21171 7.126 4.68837C7.754 4.71421 8.38 4.77921 9 4.88254C8.925 4.40754 8.925 3.92587 9 3.45087Z",
    fill: "#EA3323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3.45087C21.619 3.55421 22.246 3.61921 22.874 3.64504C22.843 3.12171 22.765 2.60004 22.641 2.08337C23.211 2.14587 23.789 2.14587 24.359 2.08337C24.235 2.59921 24.157 3.12171 24.126 3.64504C24.754 3.61921 25.38 3.55421 26 3.45087C25.925 3.92587 25.925 4.40754 26 4.88254C25.381 4.77921 24.754 4.71421 24.126 4.68837C24.157 5.21171 24.235 5.73337 24.359 6.25004C23.789 6.18754 23.211 6.18754 22.641 6.25004C22.765 5.73421 22.843 5.21171 22.874 4.68837C22.246 4.71421 21.62 4.77921 21 4.88254C21.075 4.40754 21.075 3.92587 21 3.45087Z",
    fill: "#EA3323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5492C8.381 16.4458 7.754 16.3808 7.126 16.355C7.157 16.8783 7.235 17.4 7.359 17.9167C6.789 17.8542 6.211 17.8542 5.641 17.9167C5.765 17.4008 5.843 16.8783 5.874 16.355C5.246 16.3808 4.62 16.4458 4 16.5492C4.075 16.0742 4.075 15.5925 4 15.1175C4.619 15.2208 5.246 15.2858 5.874 15.3117C5.843 14.7883 5.765 14.2667 5.641 13.75C6.211 13.8125 6.789 13.8125 7.359 13.75C7.235 14.2658 7.157 14.7883 7.126 15.3117C7.754 15.2858 8.38 15.2208 9 15.1175C8.925 15.5925 8.925 16.0742 9 16.5492Z",
    fill: "#EA3323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5492C21.619 16.4458 22.246 16.3808 22.874 16.355C22.843 16.8783 22.765 17.4 22.641 17.9167C23.211 17.8542 23.789 17.8542 24.359 17.9167C24.235 17.4008 24.157 16.8783 24.126 16.355C24.754 16.3808 25.38 16.4458 26 16.5492C25.925 16.0742 25.925 15.5925 26 15.1175C25.381 15.2208 24.754 15.2858 24.126 15.3117C24.157 14.7883 24.235 14.2667 24.359 13.75C23.789 13.8125 23.211 13.8125 22.641 13.75C22.765 14.2658 22.843 14.7883 22.874 15.3117C22.246 15.2858 21.62 15.2208 21 15.1175C21.075 15.5925 21.075 16.0742 21 16.5492Z",
    fill: "#EA3323"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2230_42440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2230_42440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoFlag);
export default __webpack_public_path__ + "static/media/geo_flag.795193d8cd3c95746d5030fccc44576c.svg";
export { ForwardRef as ReactComponent };